<template>
  <div class="container">
    <div class="news-media-filter">
      <div class="left">
        <div class="search-wrap">
          <form @submit.prevent="handleChange">
            <input
              type="text"
              class="c-input"
              :placeholder="$fn.tr('Search by keyword')"
              v-model="searchText"
            />
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24.998"
                height="24.998"
                viewBox="0 0 24.998 24.998"
              >
                <g
                  id="Group_1309"
                  data-name="Group 1309"
                  transform="translate(19679.999 90.998)"
                >
                  <path
                    id="Subtraction_52"
                    data-name="Subtraction 52"
                    d="M1300.5,21229c-4.882,0-7.9-.836-9.776-2.711s-2.723-4.9-2.723-9.787c0-4.8.858-7.8,2.781-9.721s4.919-2.779,9.718-2.779c4.892,0,7.91.84,9.788,2.723s2.711,4.893,2.711,9.777-.836,7.912-2.711,9.787S1305.394,21229,1300.5,21229Zm1.662-9.5v0l2.274,2.736.054.059a1.28,1.28,0,1,0,1.747-1.863l-2.738-2.27a5.217,5.217,0,1,0-1.338,1.338Zm-2.936-.441a3.842,3.842,0,1,1,3.847-3.836A3.848,3.848,0,0,1,1299.227,21219.059Z"
                    transform="translate(-20968 -21295)"
                    fill="#444958"
                  />
                </g>
              </svg>
            </button>
          </form>
        </div>
        <div class="custom-select-wrap withFirst" v-if="!disableSelect">
          <!-- გამოსაჩენად დაადე კლასი error custom-select-wrap დივს -->
          <CustomSelect
            :options="_.get(this.$store.state.indx, 'terms.news_category')"
            v-model="selectOption"
          />
        </div>
      </div>

      <div class="right">
        <el-date-picker
          v-model="searchDate"
          type="daterange"
          range-separator="-"
          :start-placeholder="$fn.tr('Start date')"
          :end-placeholder="$fn.tr('End date')"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="handleDate"
        >
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from "@/components/CustomSelect";

export default {
  props: ['disableSearch','disableSelect','disableDate'],
  components: {
    CustomSelect
  },

  data() {
    return {
      selectList: [
        {
          value: "Standard form"
        },
        {
          value: "Anonymous form"
        }
      ],
      searchText: "",
      selectOption: _.get(
        this.$store.state.selected_menu,
        "primary_content.term"
      ),

      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchDate: []
    };
  },

  mounted() {
    // console.log(this.itemData);
  },

  computed: {
    getCats() {
      let arr;
      let obj = {
        title: "all",
        value: "all"
      };
      arr = this.$store.state.indx.terms.news_category.map(item => {
        item.value = item.title;
        return item;
      });

      // arr.unshift(obj);
      return arr;
    }
  },

  methods: {
    handleChange() {
      this.$emit("get-search-text", this.searchText);
    },

    handleDate() {
      if (this.searchDate === null) this.searchDate = [];
      this.$emit("get-search-date", this.searchDate);
    }

    // handleSelect() {
    //   this.$emit("get-search-select", this.selectOption)
    //   console.log("WORKS WORKS WORKS")
    // }
  },

  watch: {
    selectOption() {
      this.$emit("get-search-select", this.selectOption);
      switch(this.selectOption) {
        case 115:
          window.history.pushState({}, null, '/' +this.$store.state.locale + '/personal/news?page='+ 1);
          this.$store.commit('setState', {key: 'newsAll', val: false})
          break;
        case 116:
          window.history.pushState({}, null, '/' +this.$store.state.locale + '/business/news?page='+ 1);
          this.$store.commit('setState', {key: 'newsAll', val: false})
          break;
        case 104:
          window.history.pushState({}, null, '/' +this.$store.state.locale + '/unique-banking/news?page='+ 1);
          this.$store.commit('setState', {key: 'newsAll', val: false})
          break;
        case 117:
          window.history.pushState({}, null, '/' +this.$store.state.locale + '/about-holding/news?page='+ 1);
          this.$store.commit('setState', {key: 'newsAll', val: false})
          break;
        default:
          this.$store.commit('setState', {key: 'newsAll', val: true})
          window.history.pushState({}, null, '?all=1&page='+ 1);
          // code block
      };
    },
    '$route.query.all' : {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectOption = 0;
          this.$store.commit('setState', {key: 'newsAll', val: true})
        }else {
          this.$store.commit('setState', {key: 'newsAll', val: false})

        }

      }
    }
  }
};
</script>
